<template>
	<div>
		<a-modal v-show='!ishand' id='lispget' width='33rem' v-model="visible" on-ok="handleOk1"
			v-dragModal class='myfus'
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-lisp'>
				<div style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 100%;">
					{{openstatic.name}}</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="border-radius: 0 0 10px 10px;" :style='{height: openstatic.type == "33"?"9rem":"12rem"}'>
				<div style="margin-left: 3rem;padding-top: 1.5rem;">
					<a-form-model ref='ruleForm' :model="form" labelAlign='right' :rules='rules' layout="inline"
						hideRequiredMark>
						<a-row>
							<a-col :span='12'>
								<div class="my-right">
									<a-form-model-item label='日期' prop='begindate'>
										<a-select v-model="form.begindate" class='warp_width'>
											<a-select-option :value="item" v-for='(item,ind) in diffdate' :key='ind+"bbc"'>
												{{item}}
											</a-select-option>
										</a-select>
									</a-form-model-item>
								</div>
							</a-col>
							<a-col :span='12'>
								<a-form-model-item label='至' >
									<a-select v-model="form.enddate" class='warp_width'>
										<a-select-option :value="item" v-for='(item,ind) in diffdate' :key='ind+"bba"'>
											{{item}}
										</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :span='12' v-if='openstatic.type == "22"||openstatic.type == "23"||openstatic.type == "25"'>
								<div class="my-right">
									<a-form-model-item label='訂單類型'>
										<a-select v-model="form.market" class='warp_width'>
											<a-select-option v-for="(item,inds) in admintypeArr" :key="inds+'a'"
												:value="item.text">{{item.text }}</a-select-option>

										</a-select>
									</a-form-model-item>
								</div>
							</a-col>
							<a-col :span='12' v-if='openstatic.type == "22"||openstatic.type == "23"||openstatic.type == "25"'>
								<div style='margin-left: 1.8rem;'>
									<a-form-model-item label=''>
										<a-input v-model="form.product_code" class='warp_width' placeholder="空白代表所有" />
									</a-form-model-item>
								</div>
							</a-col>
						</a-row>
					</a-form-model>
					<div style="text-align: center;">
						<button class='btn1 btnx' @click='handopen'>產成報表</button>
						<button class='btn1 btn2'>
							 <a @click="handex" :href="strurl" style="color: #fff;">導出</a>
							</button>
					</div>
				</div>
				<!-- pdfviews -->
				<div :class="['pdfviews',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()" v-if='openstatic.type == "33"'>
					<div class="pdfviewIn">
						<div class="pdfTitle">
							<img @click.stop="printEvent()" src="../../../image/icon_dayin.png">
							<!-- <img @click.stop="downLoad()" src="../../../image/icon_xiazai1.png"> -->
						</div>
						<!-- https://hk.qmisit.com/qmisAdmin/pdfView/views/pdfView.html $api.getOrderHistoryPdf-->
						<iframe id="iframePdf1"
							:src="allurl"
							style="width: 100%; height: 100%" frameborder="0"></iframe>
						<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
					</div>
				</div>
				<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()" v-else>
					<div class="pdfviewIn">
						<div class="pdfTitle">
							<img @click.stop="printEvent()" src="../../../image/icon_dayin.png">
							<!-- <img @click.stop="downLoad()" src="../../../image/icon_xiazai1.png"> -->
						</div>
						<!-- https://hk.qmisit.com/qmisAdmin/pdfView/views/pdfView.html $api.getOrderHistoryPdf-->
						<iframe id="iframePdf1"
							:src="allurl"
							style="width: 100%; height: 100%" frameborder="0"></iframe>
						<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import {
		saveFileToLink
	} from 'web-downloadfile';
	import https from '@/plugins/http.js';

	export default {
		props: ['openstatic'],
		data() {
			return {
				strurl:'#',
				allurl:'',
				pdfUrl: '',
				pdfBolUrl: '',
				pdfShow: false,
				england: 'cn',
				blob: '',
				visible: true,
				ishand: false,
				rules: {},
				form: {
					username:1000005,
					begindate:'',
					enddate:'',
					market:'全部',
					product_code:'',
					flag:this.openstatic.type=='23'||this.openstatic.type == "25"?'1':'',//23
					token: this.$store.state.token,
					m:new Date().getTime()
				},
				admintypeArr: [{
					text: '全部',
					value: ''
				}, {
					text: 'AU',
					value: '1'
				}, {
					text: 'BOND',
					value: '2'
				}, {
					text: 'HKEX',
					value: '3'
				}, {
					text: 'FUND',
					value: '4' //
				}, {
					text: 'JP',
					value: '5'
				}, {
					text: 'SGX',
					value: '6'
				}, {
					text: 'TWSE',
					value: '7'
				}, {
					text: 'US',
					value: '8'
				}, ],
				diffdate: []
			}
		},
		mounted() {
			this.getLast3Month()
		},
		methods: {
			pdfShowUNEvent() {
				this.pdfShow = false;
			},
			printEvent() {
				let _this = this;//toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
				//隐藏不想打印的部分

				// 实现打印
				// var bdhtml = document.getElementById("iframePdf1").innerHTML;
				// var sprnstr = "<!--startprint-->";
				// var eprnstr = "<!--endprint-->";
				// var prnhtml = bdhtml.substr(bdhtml.indexOf(sprnstr) + 17);
				// var prnhtml = prnhtml.substring(0, prnhtml.indexOf(eprnstr));
				// bdhtml = prnhtml;
				// window.print();
				// 完成后不隐藏
			},
			downLoad() {
				let _this = this;
				saveFileToLink(_this.pdfUrl, 'xxx', 'pdf');
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			},
			handex(){
				this.$ajax({
					url:this.$api.getpdfable,
					method:'post',
				}).then(res=>{
					if(res.data.qmiscode == 1000){
							let str = this.$api.getOrderHistoryExcel
							if(this.openstatic.type == "25"){
								str = this.$api.getReferencevalExcel
							}
							if(this.openstatic.type == "33"){
								str = this.$api.getDiscountingLogExcel
							}
							let url = ''
							for(let key in this.form){
								if(url){
									if(key =='flag'){
										if(this.form[key] !== ''){
											url += '&'+key+'='+this.form[key]
										}
									}else{
										if(key == 'market'){
											let str = this.form[key] == '全部' ?'': this.form[key]
											url += '&'+key+'='+ str
										}else{
										url += '&'+key+'='+this.form[key]}
									}
								}else{
									if(key == 'market'){
										let str = this.form[key] == '全部' ?'': this.form[key]
										url += '&'+key+'='+ str
									}else{
									url += '?'+key+'='+this.form[key]}
								}
							}
							// location.href = str + url
							this.strurl = str + url + '?m=' + Date.parse(new Date())
							return str + url
						}
				},err=>{
					
				})
			},
			handopen(record) { 
				//this.openstatic.type=='23'||
				let str = this.$api.pdfs;
				// let url = this.$api.getOrderHistoryPdf
				let url = this.$api.getOrderHistoryPdfs;
				if(this.openstatic.type == "25"){
					url = this.$api.getReferencevalPdf
				}
				if(this.openstatic.type == "33"){
					url = this.$api.getDiscountingLogPdf
				}
				url += '?m=' + Date.parse(new Date())
				for(let key in this.form){
					if(key == 'market'){
						let str = this.form[key] == '全部' ?'': this.form[key]
						url += '&'+key+'='+ str
					}else{
						url += '&'+key+'='+this.form[key]
					}
				}
				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					console.log(data)
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});

				setTimeout(() => {
					console.log(_this.pdfUrl)
					this.pdfShow = true;
				}, 500);
				// window.open(this.$api.openurls+ "/dalinji")
			},
			getLast3Month() {
				var now = new Date();
				var year = now.getFullYear();
				var month = now.getMonth() + 1; //0-11表示1-12月
				var day = now.getDate();
				var dateObj = {};
				dateObj.now = year + '-' + month + '-' + day;
				var nowMonthDay = new Date(year, month, 0).getDate(); //当前月的总天数
				if (month - 3 <= 0) { //如果是1、2、3月，年数往前推一年
					var last3MonthDay = new Date((year - 1), (12 - (3 - parseInt(month))), 0).getDate(); //3个月前所在月的总天数
					if (last3MonthDay < day) { //3个月前所在月的总天数小于现在的天日期
						dateObj.last = (year - 1) + '-' + (12 - (3 - month)) + '-' + last3MonthDay;
					} else {
						dateObj.last = (year - 1) + '-' + (12 - (3 - month)) + '-' + day;
					}
				} else {
					var last3MonthDay = new Date(year, (parseInt(month) - 3), 0).getDate(); //3个月前所在月的总天数
					if (last3MonthDay < day) { //3个月前所在月的总天数小于现在的天日期
						if (day < nowMonthDay) { //当前天日期小于当前月总天数,2月份比较特殊的月份
							dateObj.last = year + '-' + (month - 3) + '-' + (last3MonthDay - (nowMonthDay - day));
						} else {
							dateObj.last = year + '-' + (month - 3) + '-' + last3MonthDay;
						}
					} else {
						dateObj.last = year + '-' + (month - 3) + '-' + day;
					}
				}
				let arr1 = []
				dateObj.last.split('-').map(ev => {
					if (ev < 10) {
						ev = '0' + ev
					}
					arr1.push(ev)
				})
				let arr2 = []
				dateObj.now.split('-').map(ev => {
					if (ev < 10) {
						ev = '0' + ev
					}
					arr2.push(ev)
				})
				var stime = arr1.join('-'); //开始日期
				var etime = arr2.join('-'); //结束日期
				this.getdiffdate(stime, etime);
				return dateObj;
			},

			//获取两日期之间日期列表函数
			getdiffdate(stime, etime) {
				//初始化日期列表，数组
				var diffdate = new Array();
				var i = 0;
				//开始日期小于等于结束日期,并循环
				while (stime <= etime) {
					diffdate[i] = stime;

					//获取开始日期时间戳
					var stime_ts = new Date(stime).getTime();
					// console.log('当前日期：'+stime   +'当前时间戳：'+stime_ts);

					//增加一天时间戳后的日期
					var next_date = stime_ts + (24 * 60 * 60 * 1000);

					//拼接年月日，这里的月份会返回（0-11），所以要+1
					var next_dates_y = new Date(next_date).getFullYear() + '-';
					var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() +
						1) + '-' : (new Date(next_date).getMonth() + 1) + '-';
					var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() :
						new Date(next_date).getDate();

					stime = next_dates_y + next_dates_m + next_dates_d;

					//增加数组key
					i++;
				}
				this.diffdate = diffdate
				this.form.begindate = diffdate[0]
				this.form.enddate = diffdate[diffdate.length - 1]
			}
		}
	}
</script>
<style lang='scss' scoped>
	.mark-lisp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;

		div {
			text-align: center;
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.warp_width {
		width: 9rem;
	}

	.btn1 {
		width: 5rem;
		height: 2rem;
		font-size: .8rem;
		color: #fff;
		border: 0;
		border-radius: 5px;
		margin: 0 1.5rem;
	}

	.btnx {
		background-color: #2a83dd;
	}

	.btn2 {
		background-color: #ffa647;
	}
</style>
<style lang="scss">
	#lispget {
		.ant-modal-header,
		.ant-modal-body {
			background-color: #fff !important;
		}
		.ant-modal {
			top: 30vh;
		}
		.pdfview, .pdfviews {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}
		
		.pdfShow {
			display: block;
		}
		.pdfviews .pdfviewIn {
			position: fixed;
			width: 40vw;
			height: 80vh;
			left: calc(50% - 20vw);
			top: 5vh;
		}
		.pdfview .pdfviewIn {
			position: fixed;
			width: 62vw;
			height: 80vh;
			left: calc(50% - 31vw);
			top: 5vh;
		}
		.pdfviews .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}
		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}
		.pdfviews .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}

		.ant-modal-close-x {
			.anticon svg {
				color: #5cb1b9;
				position: relative;
				top: .8rem;
				right: 0;
			}
		}

		.my-right {
			text-align: right;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: 1rem;
		}

		.ant-form-item label {
			font-size: 1rem !important;
		}

		.ant-input {
			font-size: 1rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 1rem !important;
		}

		.ant-form-item-children {
			font-size: 1rem !important;
		}


		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}



		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
